export const MODULE_NAME = 'transactionshealthy'; //BaseApi
export const TRANSACTIONS_HEALTHY = 'TransactionsHealthy';
export const SET_TRANSACTIONS_HEALTHY = 'SetTransactionsHealthy';
export const LOADING_ERRORS = 'loadingErrors';
export const SET_LOADING_ERRORS = 'SetLoadingErrors';
